import { FETCHED_SHIPPING_TABLE, FETCHING_SHIPPING_TABLE } from '../actions/ShippingPageActions';
import produce from 'immer';

const initialState = {
	fetchingCountries: false,
	countries: null
};

export default class ShippingPageReducer {

	/**
	 * @param {object} state
	 * @param {object} action
	 * @param {object} globalState
	 * @return {*}
	 */
	static reduce(state = initialState, action, globalState) {
		switch (action.type) {
			// eslint-disable-next-line no-case-declarations
			case FETCHING_SHIPPING_TABLE:
				return produce(state, draftState => {
					draftState.fetchingCountries = true;
				});
			case FETCHED_SHIPPING_TABLE:
				return produce(state, draftState => {
					draftState.fetchingCountries = false;
					draftState.countries = action.countries;
				});
		}

		return state;
	}
}




// WEBPACK FOOTER //
// ./reducers/ShippingPageReducer.js